const commentItems = [
  {
    name: '影迷小陈',
    date: '2026-07-30',
    content: '密桃视频真的是我最近发现的宝藏平台！91视频资源的更新速度太快了，最新的院线电影基本都能找到高清版本。播放流畅不卡顿，比之前用的几个网站强太多了。强烈推荐给喜欢看电影的朋友！',
    rating: 5,
    tag: '忠实用户',
  },
  {
    name: '剧荒拯救者',
    date: '2026-07-28',
    content: '久久视频专区的高清修复计划太良心了！之前很多经典老片找不到清晰版本，现在终于可以重温了。4K画质下的《笑傲江湖》简直惊艳，感谢密桃视频团队的用心付出。',
    rating: 5,
    tag: '经典影迷',
  },
  {
    name: '追剧不熬夜',
    date: '2026-07-25',
    content: '用91在线视频追韩剧简直不要太爽！更新速度快，画质清晰，而且手机上直接浏览器打开就能看，不用下载乱七八糟的APP。追剧体验满分，已经把密桃视频推荐给身边所有追剧的小伙伴了。',
    rating: 5,
    tag: '韩剧爱好者',
  },
];

export default function SectionComments() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-2 justify-center">
          <div className="w-8 h-8 rounded-lg bg-accent-100 flex items-center justify-center">
            <i className="ri-chat-heart-line text-accent-600 text-lg"></i>
          </div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950">用户评价</h2>
        </div>
        <p className="text-sm text-foreground-500 mb-8 md:mb-10 text-center">听听影迷朋友们怎么说</p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {commentItems.map((item, i) => (
            <div
              key={i}
              className="p-5 rounded-xl bg-background-100/80 border border-background-200/60"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-background-200 flex items-center justify-center shrink-0">
                  <span className="text-sm font-bold text-foreground-500">{item.name.charAt(0)}</span>
                </div>
                <div className="min-w-0">
                  <div className="flex items-center gap-1.5">
                    <span className="text-sm font-semibold text-foreground-900 truncate">{item.name}</span>
                    <span className="px-1.5 py-0.5 rounded-md bg-accent-100 text-accent-700 text-xs font-medium whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                  <span className="text-xs text-foreground-400">{item.date}</span>
                </div>
              </div>
              <div className="flex items-center gap-0.5 mb-2">
                {Array.from({ length: item.rating }).map((_, ri) => (
                  <i key={ri} className="ri-star-fill text-accent-500 text-xs"></i>
                ))}
              </div>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{item.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}